import { setCookie } from '@klv/shared/utils/cookies';

const LOCALE_COOKIE_NAME = 'kl_preferred-locale';

export const savePreferredLocale = ({
  locale = '',
}) => {
  if (!locale) return;

  const expiration = new Date();
  expiration.setFullYear(expiration.getFullYear() + 1);

  setCookie({
    cookieName: LOCALE_COOKIE_NAME,
    data: locale,
    expiration: expiration.toUTCString(),
  });
};
